<template>
  <v-footer
    id="home-footer"
    color="grey darken-4"
    dark
    min-height="72"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
            <template v-for="(s,i) in social">
              <div class="d-flex flex-wrap flex-md-column justify-center">
                <a :href="s.url"><img style="width: 90px; height: 40px;margin-bottom: 4px;" :src="s.logo"/></a>
                <a
                  :key="s.id"
                  class="white--text pa-1 pa-md-0"
                  :href="s.url"
                  target="_blank"
                  style="text-align: center"
                  v-text="s.name"
                />
              </div>
              <v-responsive
                v-if="i < social.length - 1"
                :key="`divider-${s}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <!--<v-divider vertical />-->
              </v-responsive>
            </template>
          </div>
        </v-col>

        <v-col
          class="text-center text-md-right"
          cols="12"
          md="6"
        >
          <!--Copyright &copy; 2020 LingTouLu, Co,Ltd-->
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',
    data: () => ({
      social: [
        { id: 0, name: 'LTLERP', url: 'https://erp.ltl.kr', logo: 'https://ltlerp.oss-cn-beijing.aliyuncs.com/imgs/site/main_logo.png' },
        { id: 1, name: 'AFTERSHIP', url: 'https://www.aftership.com/couriers/ltl', logo: 'https://ltlerp.oss-cn-beijing.aliyuncs.com/imgs/site/aftership.jpg' }
      ],
    }),
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
